module.exports = "/*div.container {\n  height: calc(100vh - 50px);\n}*/\nimg.my-picture {\n  width: 15vw;\n  height: auto;\n  color: #e0e0e0; }\n"